import React from 'react'

import { theme } from '@acorns/grove'
import { Loader } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { trackAiChatSendFeedbackLoadingContainerViewedPayload } from 'generated/trackingEvents'
import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'

import { StyledButton, StyledDrawer } from './styled-components'
import { AI_CHAT_FEEDBACK_ORIGIN } from './utils/constants'

const SuccessContainer = styled.div`
  display: grid;
  grid-template-rows: 94px 62px;
  row-gap: 20px;
  margin-bottom: 50px;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const SuccessText = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  padding: 0;
  margin: 0;
`
const SuccessBody = styled.span<{ isInvisible: boolean }>`
  visibility: ${({ isInvisible }) => (isInvisible ? 'hidden' : 'visible')};
  font-size: 14px;
  font-weight: 400;
  padding: 0;
  margin: 0;
`

const SuccessDrawer = ({
  isOpen,
  showSuccess,
  isSuccessAnimationCompleted,
  handleAnimationEnd,
  handleClose,
  messages,
}: {
  isOpen: boolean
  showSuccess: boolean
  isSuccessAnimationCompleted: boolean
  handleAnimationEnd: () => void
  handleClose: () => void
  messages: {
    successTitle: string
    successBody: string
    submittingMessage: string
  }
}) => {
  const { getRemoteString } = useRemoteStrings()
  const feedbackLoadingRef = useAnalyticsComponentViewed({
    generatedPayload: trackAiChatSendFeedbackLoadingContainerViewedPayload({
      origin: AI_CHAT_FEEDBACK_ORIGIN,
    }),
  })

  return (
    <StyledDrawer
      isOpen={isOpen}
      showClose={false}
      customBreakpoint={theme.dimensions.breakpointsSmall}
    >
      <SuccessContainer ref={feedbackLoadingRef}>
        <Loader
          loading={showSuccess}
          minimumAnimationTime={1000}
          endSegment={[90, 160]}
          isStatic={isSuccessAnimationCompleted}
          onAnimationEnd={handleAnimationEnd}
        />
        <SuccessText>
          {isSuccessAnimationCompleted
            ? messages.successTitle
            : messages.submittingMessage}
          <SuccessBody isInvisible={!isSuccessAnimationCompleted}>
            {messages.successBody}
          </SuccessBody>
        </SuccessText>
      </SuccessContainer>
      <StyledButton
        onPress={handleClose}
        isInvisible={!isSuccessAnimationCompleted}
        key="close-button"
      >
        {getRemoteString({
          key: 'global.close',
        })}
      </StyledButton>
    </StyledDrawer>
  )
}
export { SuccessDrawer }
